
export const common = {
  // Navbar
  "nav.home": "Home",
  "nav.about": "About",
  "nav.services": "Services",
  "nav.portfolio": "Portfolio",
  "nav.contact": "Contact",
  "nav.startInvesting": "Start Investing",

  // Hero
  "hero.badge": "Est. 2019",
  "hero.title1": "Building",
  "hero.title2": "Tomorrow's",
  "hero.title3": "Legacy Today",
  "hero.subtitle": "Investment Excellence",
  "hero.description": "A UAE-based holding and investment creating long-term value across energy, technology, and industrial sectors through strategic ownership and active governance.",
  "hero.discoverMore": "Discover More",
  "hero.getInTouch": "Get in Touch",
  "hero.portfolioCompanies": "Portfolio Companies",
  "hero.headquarters": "Headquarters",
  "hero.established": "Established",
  "hero.strategicGrowth": "Strategic Growth",
  "hero.valueCreation": "Long-term Value Creation",
  "hero.scroll": "Scroll",

  // About
  "about.label": "About Us",
  "about.title1": "Strategic Investment",
  "about.title2": "Excellence",
"about.description": "ALEBEL Investment is a private holding and investment focused on building long-term value through strategic investments, active ownership, and operational excellence across diversified sectors.The Alebel Investment supports scalable businesses and innovation-driven ventures across energy, technology, electronics, infrastructure, and industrial solutions.",
  "about.parentEntity": "Parent Entity",
  "about.parentEntityDesc": "Operating as a parent entity, providing capital, governance, and strategic oversight to subsidiary and partner companies.",
  "about.uaeBased": "UAE Based",
  "about.uaeBasedDesc": "Headquartered in the United Arab Emirates, focusing on regional and international markets with strategic investments.",
  "about.activeOwnership": "Active Ownership",
  "about.activeOwnershipDesc": "Supporting portfolio companies through financial backing, strategic planning, and business development support.",
  "about.innovationFocus": "Innovation Focus",
  "about.innovationFocusDesc": "Strong focus on scalable and innovation-driven businesses in energy, technology, and industrial solutions.",
  "about.investmentSectors": "Investment Sectors",
  "about.learnMore": "Learn More About Us",
  "about.ceoQuote1": "At ALEBEL Investment, our vision is to build a diversified and future-focused investment that creates sustainable long-term value for shareholders, partners, and communities.",
"about.ceoQuote2": "We focus on identifying scalable opportunities, empowering leadership teams, and supporting innovation-driven businesses capable of adapting to the evolving global economy.",
  "about.ceoName": "Mohamed Hamad Bin Mnaidherh",
  "about.ceoTitle": "Chief Executive Officer",
  "about.mhbm": "MHBM",

  // Sectors
  "sector.energy": "Energy",
  "sector.technology": "Technology",
  "sector.manufacturing": "Manufacturing",
  "sector.electronics": "Electronics",
  "sector.industrial": "Industrial Solutions",

  // Services
  "services.label": "Our Services",
  "services.title1": "How We",
  "services.title2": "Work",
  "services.description": "Our strategic approach to investment and value creation through comprehensive support",
  "services.evaluation": "Evaluation",
  "services.evaluationDesc": "We continuously search for investment opportunities with scalable business models and strong leadership teams.",
  "services.dueDiligence": "Due Diligence",
  "services.dueDiligenceDesc": "We conduct comprehensive financial, technical, and legal analysis to ensure alignment with our criteria.",
  "services.activeManagement": "Active Management",
  "services.activeManagementDesc": "We play an active role at the board level to support management teams strategically.",
  "services.valueCreation": "Value Creation",
  "services.valueCreationDesc": "We provide guidance, operational support, and access to our networks to drive growth.",
  "services.forCompanies": "For Companies",
  "services.corporateServices": "Corporate Services",
  "services.corporateDesc": "We support our subsidiary companies to operate independently while benefiting from the financial strength and governance.",
  "services.corporate1": "Financial backing and capital support",
  "services.corporate2": "Strategic planning and governance",
  "services.corporate3": "Business development support",
  "services.corporate4": "Access to group resources and networks",
  "services.forIndividuals": "For Individuals",
  "services.entrepreneurSupport": "Entrepreneur Support",
  "services.entrepreneurDesc": "Empowering entrepreneurs and innovators to transform ideas into sustainable businesses through comprehensive support.",
  "services.entrepreneur1": "Supporting founders in turning ideas into companies",
  "services.entrepreneur2": "Investing in early-stage and growth-stage startups",
  "services.entrepreneur3": "Providing legal structuring and seed capital",
  "services.entrepreneur4": "Mentorship and strategic advice",
  "services.entrepreneur5": "Technology and product development guidance",
  "services.learnMore": "Learn More",

  // Projects
  "projects.label": "Portfolio",
  "projects.title1": "Flagship",
  "projects.title2": "Projects",
  "projects.description": "Strategic investments across energy, technology, and construction sectors driving innovation and growth",
  "projects.energy.title": "ALEBEL Energy Solutions",
  "projects.energy.desc": "Development and investment in battery packs, battery management systems (BMS), and energy storage solutions for power tools, electric mobility, and industrial applications.",
  "projects.electronics.title": "ALEBEL Electronics",
  "projects.electronics.desc": "Investment in electronics product development, embedded systems, IoT devices, and RF communication solutions for smart control and monitoring applications.",
  "projects.construction.title": "TOP TEAM Construction",
  "projects.construction.desc": "Top Team Construction is a strategic portfolio company specializing in construction, infrastructure development, and turnkey building projects.",
  "projects.viewDetails": "View Details",
  "projects.investmentFocus": "Investment Focus",
  "projects.investmentFocusDesc": "Our portfolio companies operate across strategic sectors, supported through capital investment, strategic guidance, and operational expertise.",
  "projects.viewAll": "View All Projects",

  // Tags
  "tag.energy": "Energy",
  "tag.batterySystems": "Battery Systems",
  "tag.industrial": "Industrial",
  "tag.electronics": "Electronics",
  "tag.iot": "IoT",
  "tag.smartSystems": "Smart Systems",
  "tag.construction": "Construction",
  "tag.infrastructure": "Infrastructure",
  "tag.development": "Development",

  // Values
  "values.label": "Our Values",
  "values.title1": "Guiding",
  "values.title2": "Principles",
  "values.description": "Our core values guide every investment decision and partnership we undertake",
  "values.integrity": "Integrity",
  "values.integrityDesc": "We uphold the highest standards of honesty, accountability, and transparency in all our dealings, ensuring trust with our partners, investors, and portfolio companies.",
  "values.longTerm": "Long-Term Perspective",
  "values.longTermDesc": "We make investment decisions guided by a long-term perspective, identifying opportunities that align with sustainable growth and future market trends.",
  "values.excellence": "Excellence",
  "values.excellenceDesc": "We strive for excellence in all aspects of our investments and governance, ensuring that our portfolio companies achieve operational, financial, and strategic success.",
  "values.innovation": "Innovation",
  "values.innovationDesc": "We support innovative ideas and technologies, helping portfolio companies scale, adapt, and remain competitive in rapidly evolving markets.",
  "values.collaboration": "Collaboration",
  "values.collaborationDesc": "We believe in building strong partnerships with founders, management teams, and stakeholders to create value through collaboration, guidance, and support.",
  "values.quote": "Our values are the foundation of our success and the cornerstone of our relationships with partners, investors, and portfolio companies.",

  // CTA
  "cta.label": "Get in Touch",
  "cta.title1": "Let's Build the",
  "cta.title2": "Future Together",
  "cta.description": "Whether you're seeking investment, partnership opportunities, or strategic guidance, we're here to help you achieve your goals.",
  "cta.contactUs": "Contact Us",
  "cta.callNow": "Call Now",
  "cta.phone": "Phone",
  "cta.email": "Email",
  "cta.website": "Website",
  "cta.location": "Location",

  // Footer
  "footer.description": "Building a robust and diversified investment that creates long-term value across energy, technology, and industrial sectors.",
  "footer.quickLinks": "Quick Links",
  "footer.portfolio": "Portfolio",
  "footer.contact": "Contact",
  "footer.aboutUs": "About Us",
  "footer.batteryEnergy": "Battery & Energy Storage",
  "footer.iotSmart": "IoT & Smart Systems",
  "footer.infrastructure": "Infrastructure Development",
  "footer.copyright": "© 2026 ALEBEL Investment. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",

  // Language
  "language": "Language",
  "language.en": "English",
  "language.ar": "العربية",

  // About Page
  "aboutPage.breadcrumb.home": "Home",
  "aboutPage.breadcrumb.about": "About Us",
  "aboutPage.hero.label": "Who We Are",
  "aboutPage.hero.title1": "About",
  "aboutPage.hero.title2": "ALEBEL",
  "aboutPage.hero.description": "A private holding and investment established to invest in, acquire, and manage a diversified portfolio of businesses across strategic sectors.",
  "aboutPage.story.title1": "Our",
  "aboutPage.story.title2": "Story",
  "aboutPage.story.p1": "ALEBEL Investment operates as a strategic holding focused on acquiring, developing, and supporting businesses with high growth potential across regional and international markets.",
"aboutPage.story.p2": "Headquartered in the United Arab Emirates, provides capital support, governance oversight, strategic planning, and operational guidance to its portfolio companies.",
"aboutPage.story.p3": "With a long-term investment philosophy and innovation-focused approach, ALEBEL aims to create sustainable value through disciplined investments and active partnership models.",
  // "aboutPage.story.p4": "The company does not engage in direct operations; instead, it supports its portfolio companies through financial backing, strategic planning, corporate governance, and business development support.",
  // "aboutPage.story.p5": "Alebel Investment's investment interests include energy, technology, manufacturing, electronics, and industrial solutions, with a strong focus on scalable and innovation-driven businesses in regional and international markets.",
  "aboutPage.established": "Established",
  "aboutPage.process.label": "Our Process",
  "aboutPage.process.title1": "How We",
  "aboutPage.process.title2": "Work",
  "aboutPage.process.step1.title": "Evaluation",
"aboutPage.process.step1.desc": "We continuously identify and assess high-potential investment opportunities with scalable business models, operational strength, and experienced leadership teams.",
"aboutPage.process.step2.title": "Due Diligence",
"aboutPage.process.step2.desc": "We conduct comprehensive financial, operational, technical, and legal assessments to ensure alignment with our investment strategy and long-term objectives.",
"aboutPage.process.step3.title": "Active Management",
"aboutPage.process.step3.desc": "We work closely with management teams by providing strategic oversight, governance support, and operational guidance to drive sustainable growth.",
"aboutPage.process.step4.title": "Value Creation",
"aboutPage.process.step4.desc": "We support portfolio companies through capital allocation, strategic planning, operational improvement, and access to our business network and resources.",
  "aboutPage.values.label": "Our Values",
  "aboutPage.values.title1": "Guiding",
  "aboutPage.values.title2": "Principles",
  "aboutPage.values.integrity": "Integrity",
  "aboutPage.values.integrityDesc": "We uphold the highest standards of transparency, accountability, and ethical business conduct across all our operations and partnerships.",
  "aboutPage.values.longTerm": "Long-Term Perspective",
  "aboutPage.values.longTermDesc": "We pursue sustainable investment opportunities guided by disciplined decision-making and long-term value creation.",
  "aboutPage.values.excellence": "Excellence",
  "aboutPage.values.excellenceDesc": "We strive for operational excellence, strategic discipline, and continuous improvement across all business activities.",
  "aboutPage.values.innovation": "Innovation",
  "aboutPage.values.innovationDesc": "We support innovation-driven businesses and emerging technologies that contribute to future economic growth and industrial transformation.",
  "aboutPage.values.collaboration": "Collaboration",
  "aboutPage.values.collaborationDesc": "We believe in building strong partnerships with founders, stakeholders, and management teams to achieve shared success.",

  // Services Page
  "servicesPage.breadcrumb.home": "Home",
  "servicesPage.breadcrumb.services": "Services",
  "servicesPage.hero.label": "What We Offer",
  "servicesPage.hero.title1": "Our",
  "servicesPage.hero.title2": "Services",
  "servicesPage.hero.description": "Comprehensive investment, strategic advisory, and business support services designed to accelerate sustainable growth for companies and entrepreneurs.",
  "servicesPage.corporate.label": "For Companies",
  "servicesPage.corporate.title1": "Corporate",
  "servicesPage.corporate.title2": "Services",
  "servicesPage.corporate.description": "We support portfolio and partner companies through strategic guidance, governance frameworks, operational support, and long-term business development initiatives.",
  "servicesPage.corporate.item1.title": "Financial Backing",
  "servicesPage.corporate.item1.desc": "Capital support and structured financing solutions for strategic growth initiatives.",
  "servicesPage.corporate.item2.title": "Strategic Planning",
  "servicesPage.corporate.item2.desc": "Long-term business planning and market positioning strategies.",
  "servicesPage.corporate.item3.title": "Corporate Governance",
  "servicesPage.corporate.item3.desc": "Board-level oversight, governance frameworks, and organizational structure development.",
  "servicesPage.corporate.item4.title": "Business Development",
  "servicesPage.corporate.item4.desc": "Market expansion strategies, partnership opportunities, and commercial growth support.",
  "servicesPage.corporate.item5.title": "Network Access",
  "servicesPage.corporate.item5.desc": "Access to strategic business relationships, investors, and industry networks.",
  "servicesPage.individual.label": "For Individuals",
  "servicesPage.individual.title1": "Entrepreneur",
  "servicesPage.individual.title2": "Support",
  "servicesPage.individual.description": "We empower entrepreneurs and innovation-driven founders by transforming scalable ideas into sustainable businesses through investment, mentorship, and strategic support.",
  "servicesPage.individual.item1.title": "Idea to Company",
  "servicesPage.individual.item1.desc": "Supporting founders in transforming innovative concepts into operational businesses.",
  "servicesPage.individual.item2.title": "Startup Investment",
  "servicesPage.individual.item2.desc": "Investing in early-stage and growth-stage ventures with strong market potential.",
  "servicesPage.individual.item3.title": "Legal Structuring",
  "servicesPage.individual.item3.desc": "Supporting legal setup, business structuring, and foundational operational frameworks.",
  "servicesPage.individual.item4.title": "Mentorship",
  "servicesPage.individual.item4.desc": "Providing strategic guidance, operational mentorship, and growth advisory.",
  "servicesPage.individual.item5.title": "Technology Guidance",
  "servicesPage.individual.item5.desc": "Supporting product development, technology strategy, and innovation execution.",
  "servicesPage.cta.title1": "Ready to",
  "servicesPage.cta.title2": "Partner",
  "servicesPage.cta.title3": "with Us?",
  "servicesPage.cta.description": "Whether you're a company seeking investment or an entrepreneur with a vision, we're here to help.",
  "servicesPage.cta.button": "Get in Touch",

  // Portfolio Page
"portfolioPage.breadcrumb.home": "Home",
"portfolioPage.breadcrumb.portfolio": "Portfolio",
"portfolioPage.hero.label": "Our Investments",
"portfolioPage.hero.title1": "Portfolio",
"portfolioPage.hero.title2": "Companies",
"portfolioPage.hero.description": "A diversified portfolio of strategic ventures focused on sustainable growth, industrial innovation, and long-term value creation.",
"portfolioPage.energy.title": "ALEBEL Energy Solutions",
"portfolioPage.energy.desc": "Development and investment in battery packs, battery management systems (BMS), and energy storage solutions for power tools, electric mobility, and industrial applications.",
"portfolioPage.energy.fullDesc": "ALEBEL Energy Solutions focuses on advanced battery technologies, energy storage systems, and sustainable power infrastructure supporting the global energy transition.",
"portfolioPage.electronics.title": "ALEBEL Electronics",
"portfolioPage.electronics.desc": "Investment in electronics product development, embedded systems, IoT devices, and RF communication solutions for smart control and monitoring applications.",
"portfolioPage.electronics.fullDesc": "ALEBEL Electronics develops advanced electronic systems, IoT technologies, and intelligent communication solutions that support automation and digital transformation.",
"portfolioPage.construction.title": "TOP TEAM Construction",
"portfolioPage.construction.desc": "Top Team Construction is a strategic portfolio company specializing in construction, infrastructure development, and turnkey building projects.",
"portfolioPage.construction.fullDesc": "TOP TEAM Construction specializes in infrastructure, commercial construction, and turnkey development projects with a strong commitment to quality, safety, and operational excellence.",
"portfolioPage.keyFocus": "Key Focus Areas:",
"portfolioPage.sectors.label": "Investment Focus",
"portfolioPage.sectors.title1": "Strategic",
"portfolioPage.sectors.title2": "Sectors",
"portfolioPage.sectors.energy": "Energy",
"portfolioPage.sectors.energyDesc": "Advanced energy infrastructure and sustainable power solutions.",
"portfolioPage.sectors.technology": "Technology",
"portfolioPage.sectors.technologyDesc": "Innovation-driven digital systems and intelligent technologies.",
"portfolioPage.sectors.manufacturing": "Manufacturing",
"portfolioPage.sectors.manufacturingDesc": "Industrial production and advanced manufacturing capabilities.",
"portfolioPage.sectors.electronics": "Electronics",
"portfolioPage.sectors.electronicsDesc": "Smart electronic systems and communication technologies.",
"portfolioPage.sectors.industrial": "Industrial",
"portfolioPage.sectors.industrialDesc": "Industrial infrastructure and automation-focused solutions.",
"portfolioPage.sectors.agricultural": "Agricultural",
"portfolioPage.sectors.agriculturalDesc": "Investment in agricultural enterprises and sustainable farming solutions.",
"portfolioPage.sectors.tourism": "Tourism",
"portfolioPage.sectors.tourismDesc": "Investment in tourism projects and hospitality management.",
"portfolioPage.sectors.healthcare": "Healthcare",
"portfolioPage.sectors.healthcareDesc": "Investment in healthcare services and medical development.",
"portfolioPage.sectors.commercial": "Commercial",
"portfolioPage.sectors.commercialDesc": "Investment in commercial enterprises and business management.",
"portfolioPage.sectors.oilgas": "Oil & Gas",
"portfolioPage.sectors.oilgasDesc": "Investment in oil and natural gas projects.",
"portfolioPage.sectors.educational": "Educational",
"portfolioPage.sectors.educationalDesc": "Investment in educational enterprises and learning institutions.",
"portfolioPage.cta.title1": "Interested in",
"portfolioPage.cta.title2": "Partnership",
"portfolioPage.cta.description": "We're always looking for innovative companies and entrepreneurs to partner with.",
"portfolioPage.cta.button": "Contact Us",
"portfolioPage.tags.energy": "Energy Storage",
"portfolioPage.tags.batterySystems": "Battery Technologies",
"portfolioPage.tags.industrial": "Industrial Energy Solutions",
"portfolioPage.tags.electricMobility": "Electric Mobility",
"portfolioPage.tags.electronics": "Electronics",
"portfolioPage.tags.iot": "IoT",
"portfolioPage.tags.smartSystems": "Smart Systems",
"portfolioPage.tags.rfCommunication": "RF Communication",
"portfolioPage.tags.construction": "Construction",
"portfolioPage.tags.infrastructure": "Infrastructure",
"portfolioPage.tags.development": "Development",
"portfolioPage.tags.turnkeyProjects": "Turnkey Projects",
"portfolioPage.rd.title": "ALEBEL R&D",
"portfolioPage.rd.desc": "Research & Development",
"portfolioPage.rd.fullDesc": "ALEBEL R&D drives innovation through advanced research and technology development across energy, robotics, automation, and industrial systems.",
"portfolioPage.robotics.title": "ALEBEL Robotics",
"portfolioPage.robotics.desc": "Robotics & Automation",
"portfolioPage.robotics.fullDesc": "ALEBEL Robotics develops intelligent robotic systems and automation technologies designed to improve industrial productivity and smart manufacturing capabilities.",
"portfolioPage.device.title": "ALEBEL Device",
"portfolioPage.device.desc": "Smart Devices & Electronics",
"portfolioPage.device.fullDesc": "ALEBEL Device designs and manufactures advanced electronic hardware and smart control systems for industrial, commercial, and consumer applications.",
"portfolioPage.tags.research": "Research",
"portfolioPage.tags.innovation": "Innovation",
"portfolioPage.tags.robotics": "Robotics",
"portfolioPage.tags.automation": "Automation",
"portfolioPage.tags.ai": "AI",
"portfolioPage.tags.industrial.solutions": "Industrial Solutions",
"portfolioPage.tags.devices": "Smart Devices",
"portfolioPage.tags.embedded.systems": "Embedded Systems",
"portfolioPage.tech.title": "ALEBEL Tech",
"portfolioPage.tech.desc": "Integrated technology solutions driving digital transformation.",
"portfolioPage.tech.fullDesc": "ALEBEL Tech develops integrated digital platforms, enterprise software solutions, and technology infrastructure that accelerate digital transformation for businesses across the UAE and regional markets.",
"portfolioPage.tags.digital": "Digital",
"portfolioPage.tags.software": "Software",
"portfolioPage.tags.technology.development": "Technology Development",

  // Contact Page
  "contactPage.breadcrumb.home": "Home",
  "contactPage.breadcrumb.contact": "Contact",
  "contactPage.hero.label": "Get in Touch",
  "contactPage.hero.title1": "Contact",
  "contactPage.hero.title2": "Us",
  "contactPage.hero.description": "Ready to discuss investment opportunities or partnership? We'd love to hear from you.",
  "contactPage.form.title": "Send us a Message",
  "contactPage.form.success": "Thank you! Your message has been sent successfully.",
  "contactPage.form.name": "Full Name",
  "contactPage.form.namePlaceholder": "Your name",
  "contactPage.form.email": "Email Address",
  "contactPage.form.emailPlaceholder": "your@email.com",
  "contactPage.form.company": "Company",
  "contactPage.form.companyPlaceholder": "Your company",
  "contactPage.form.subject": "Subject",
  "contactPage.form.subjectPlaceholder": "Select a subject",
  "contactPage.form.subjectInvestment": "Investment Inquiry",
  "contactPage.form.subjectPartnership": "Partnership Opportunity",
  "contactPage.form.subjectStartup": "Startup Support",
  "contactPage.form.subjectGeneral": "General Inquiry",
  "contactPage.form.message": "Message",
  "contactPage.form.messagePlaceholder": "Tell us about your inquiry...",
  "contactPage.form.submit": "Send Message",
  "contactPage.form.sending": "Sending...",
  "contactPage.info.title": "Contact Information",
  "contactPage.info.description": "Whether you're seeking investment, partnership opportunities, or strategic guidance, we're here to help you achieve your goals.",
  "contactPage.info.phone": "Phone",
  "contactPage.info.email": "Email",
  "contactPage.info.website": "Website",
  "contactPage.info.location": "Location",
  "contactPage.info.locationValue": "Dubai, United Arab Emirates",
  "contactPage.info.locationDesc": "Office No 501, 5th Floor, Nasco Building, Salah Al Din, Dubai, UAE",
  //"contactPage.info.locationDesc": "Serving regional and international markets",

  "investPage.hero.label": "Investment Opportunities",
  "investPage.hero.title1": "Start",
  "investPage.hero.title2": "Investing",
  "investPage.hero.description": "Partner with ALEBEL and invest in sectors that shape tomorrow's economy.",  "investPage.form.title": "Investment Inquiry",
  "investPage.form.name": "Full Name",
  "investPage.form.namePlaceholder": "Your name",
  "investPage.form.email": "Email Address",
  "investPage.form.emailPlaceholder": "your@email.com",
  "investPage.form.company": "Company",
  "investPage.form.companyPlaceholder": "Your company",
  "investPage.form.message": "Message",
  "investPage.form.messagePlaceholder": "Tell us about your interest in this investment...",
  "investPage.form.submit": "Send Inquiry",
  "investPage.form.sending": "Sending...",
  "investPage.form.success": "Thank you! Your inquiry has been sent successfully.",
  "investPage.form.close": "Close",
  "investPage.investments.agricultural": "Investment in Agricultural Enterprises & Management",
  "investPage.investments.tourist": "Investment in Tourist Enterprises & Management",
  "investPage.investments.healthcare": "Investment in Healthcare Enterprises & Development",
  "investPage.investments.commercial": "Investment in Commercial Enterprises & Management",
  "investPage.investments.technological": "Investment in Technological Enterprises & Management",
  "investPage.investments.energy": "Investment in Energy Enterprises & Management",
  "investPage.investments.oil": "Investment in Oil & Natural Gas Projects",
  "investPage.investments.industrial": "Investment in Industrial Enterprises & Management",
  "investPage.investments.educational": "Investment in Educational Enterprises & Management",

  "sector.agricultural": "Agricultural",
  "sector.tourism": "Tourism",
  "sector.healthcare": "Healthcare",
  "sector.commercial": "Commercial",
  "sector.oilgas": "Oil & Gas",
  "sector.educational": "Educational",

  "aboutPage.highlights.uaeBased": "UAE-Based Investment Sector",
"aboutPage.highlights.uaeBasedDesc": "Headquartered in Dubai, UAE, with a focus on regional and international investment opportunities.",
"aboutPage.highlights.multiSector": "Multi-Sector Portfolio",
"aboutPage.highlights.multiSectorDesc": "Diversified investments across energy, technology, electronics, construction, and industrial sectors.",
"aboutPage.highlights.innovation": "Innovation-Focused Investments",
"aboutPage.highlights.innovationDesc": "Supporting scalable, innovation-driven businesses that shape the future of industry and technology.",
"aboutPage.highlights.longTerm": "Strategic Long-Term Growth",
"aboutPage.highlights.longTermDesc": "Disciplined investment philosophy focused on sustainable value creation over the long term.",
"aboutPage.highlights.regional": "Regional Expansion Strategy",
"aboutPage.highlights.regionalDesc": "Actively expanding portfolio presence across GCC and regional markets.",
"aboutPage.whyPartner.vision": "Long-Term Investment Vision",
"aboutPage.whyPartner.visionDesc": "We invest with a long-term perspective, supporting businesses through all stages of growth.",
"aboutPage.whyPartner.support": "Strategic Operational Support",
"aboutPage.whyPartner.supportDesc": "We provide hands-on strategic guidance, governance, and operational support to portfolio companies.",
"aboutPage.whyPartner.expertise": "Industry Expertise",
"aboutPage.whyPartner.expertiseDesc": "Deep knowledge across energy, technology, construction, and industrial sectors in the UAE and region.",
"aboutPage.whyPartner.innovation": "Innovation-Focused Approach",
"aboutPage.whyPartner.innovationDesc": "We actively seek and support innovation-driven businesses with scalable potential.",
"aboutPage.whyPartner.market": "Regional Market Access",
"aboutPage.whyPartner.marketDesc": "Leveraging strong regional networks and market relationships to accelerate business growth.",

"projects.store.title": "ALEBEL Store",
"projects.store.desc": "A premium e-commerce platform curating exclusive products and luxury collections, blending refined retail experiences with cutting-edge digital commerce.",
"projects.tech.title": "ALEBEL Tech",
"projects.tech.desc": "Developing integrated technology solutions and innovative digital services that support digital transformation and enhance operational efficiency across various sectors.",
"projects.healthcare.title": "ALEBEL Healthcare",
"projects.healthcare.desc": "Investing in healthcare and pharmaceutical ventures that advance patient outcomes, medical innovation, and accessible care across the region.",
"projects.racing.title": "ALEBEL Racing",
"projects.racing.desc": "Pursuing excellence in motorsport through strategic investment in racing teams, performance engineering, and the culture of speed.",
"projects.device.title": "ALEBEL Device",
"projects.device.desc": "Designing and manufacturing innovative electronic devices and smart control systems for industrial, commercial, and consumer applications.",
"projects.rnd.title": "ALEBEL Research & Development",
"projects.rnd.desc": "Pioneering research and development in emerging technologies, driving innovation across energy, electronics, and industrial sectors in the UAE and beyond.",
"projects.websiteLabel": "Website",
"tag.luxury": "Luxury",
"tag.ecommerce": "E-Commerce",
"tag.retail": "Retail",
"tag.technology": "Technology",
"tag.digital": "Digital",
"tag.software": "Software",
"tag.healthcare": "Healthcare",
"tag.pharmaceuticals": "Pharmaceuticals",
"tag.wellness": "Wellness",
"tag.motorsport": "Motorsport",
"tag.performance": "Performance",
"tag.racing": "Racing",
"tag.devices": "Devices",
"tag.smartTech": "Smart Tech",
"tag.research": "Research",
"tag.innovation": "Innovation",
"tag.technologyDev": "Technology",

"portfolioPage.store.title": "ALEBEL Store",
"portfolioPage.store.desc": "Luxury E-Commerce",
"portfolioPage.store.fullDesc": "A premium e-commerce platform curating exclusive products and luxury collections, blending refined retail experiences with cutting-edge digital commerce.",
"portfolioPage.healthcare.title": "ALEBEL Healthcare",
"portfolioPage.healthcare.desc": "Healthcare & Pharmaceuticals",
"portfolioPage.healthcare.fullDesc": "Investing in healthcare and pharmaceutical ventures that advance patient outcomes, medical innovation, and accessible care across the region.",
"portfolioPage.racing.title": "ALEBEL Racing",
"portfolioPage.racing.desc": "Motorsport & Performance",
"portfolioPage.racing.fullDesc": "Pursuing excellence in motorsport through strategic investment in racing teams, performance engineering, and the culture of speed.",
"portfolioPage.visitWebsite": "Visit Website",
"portfolioPage.metrics.companies": "Portfolio Companies",
"portfolioPage.metrics.sectors": "Investment Sectors",
"portfolioPage.metrics.headquartered": "Headquartered",
"portfolioPage.metrics.uaeValue": "UAE",
"portfolioPage.metrics.companyProfile": "Company Profile",
"portfolioPage.metrics.established": "Established",
"portfolioPage.metrics.company": "COMPANY",
"portfolioPage.metrics.profile": "Profile"


};



export default common;
